var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m16 3-9 9a467 467 0 0 0 9 9h.5c.4-.3.6-.7.4-1 0-.2-1.8-2-4-4.1L9.2 12l4-3.9 3.9-4c.1-.7-.5-1.3-1-1Z",
    clipRule: "evenodd"
  })));
};
export { SvgChevronLeft as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9Im5vbmUiPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJtMTYgMy05IDlhNDY2LjcgNDY2LjcgMCAwIDAgOSA5aC41Yy40LS4zLjYtLjcuNC0xIDAtLjItMS44LTItNC00LjFMOS4yIDEybDQtMy45IDMuOS00Yy4xLS43LS41LTEuMy0xLTFaIiBmaWxsPSIjMDAwIi8+PC9zdmc+Cg==";